<template>  
  <v-card>
    <v-toolbar flat>      
      <v-text-field flat dense filled
        v-model="term"
        append-icon="search"
        label="Search"
        single-line
        hide-details        
        @input="search"
        style="max-width:200px"
      ></v-text-field>                 
      <v-spacer/>
      <v-btn fab color="green" dark small absolute right :to="{name:'master/quetionnaire/form'}"><v-icon>add</v-icon></v-btn>                      
    </v-toolbar>
    <v-card-text class="pa-0">      
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">            
            <v-data-table dense 
              :headers="headers"
              :items="items"              
              :loading="loading"
              loading-text="Loading... Please wait"
              :items-per-page="-1"
              hide-default-footer  
              :options.sync="pagination" 
              must-sort                       
            >               
              <template v-slot:item.no="{ item }">{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}</template>
              <template v-slot:item.color="{ item }"><v-chip label :color="item.color" small dark>{{ item.color }}</v-chip></template>
              <template v-slot:item.area="{ item }">
                <template v-if="item.nodes && item.nodes.length">
                  <template v-for="(node, i) in item.nodes">{{i==0?node.name:', '+node.name}}</template>
                </template>
                <template v-else>
                  {{item.node ? item.node.name : ''}}
                </template>                
              </template>
              <template v-slot:item.status="{ item }"><v-chip :class="item.status === 1 ? 'green white--text':''" small>{{ status[item.status] }}</v-chip></template>
              <template v-slot:item.action="{ item }">
                <v-btn icon small color="blue" :to="{name:'master/quetionnaire/form',query:{id:item.id}}"><v-icon>edit</v-icon></v-btn>
                <v-btn icon small color="red" v-if="item.status == 0" @click="removeJilid(item)"><v-icon>delete_forever</v-icon></v-btn>
              </template>              
            </v-data-table>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="totalPages"
                circle
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-flex>          
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card> 
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/master/Quetionnaire'
const  model = new Model()

export default {
  data () {
    return {
      term : null,
      headers:[
        {text:'No', value:'no'},        
        {text:'Name', value:'name'},
        {text:'Description', value:'description'},
        {text:'Area', value:'area'},
        {text:'Distribusi', value:'lembar'},
        {text:'Cust Dist', value:'lembar_custom'},
        {text:'Status', value:'status'},
        {text:'Color', value:'color'},
        {text:'#', value:'action', align:'center', width:100}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,      
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    },    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : '-id';                          
      
      const params = {
        perPage: 20,
        page: this.page,
        q: this.term,
        sort:sortby,
        expand:'node,nodes'
      }

      model.all(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },   
    
    removeJilid(item){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {                 
        if (result.value) {                    
          model.deleteOnline({id:item.id}).then(()=>{          
            this.readItems(); 
          })
        }
      });
    }
  },  
}
</script>